import { bodyElem } from './globals';
import { primaryDir } from './documentLocation';

const resetPage = (url) => {
    if (url === primaryDir) {
        document.head.innerHTML = ''; 
        bodyElem.innerHTML = '';
    }
}

export {
    resetPage
}